<template>
  <div class="modal fade" id="measurement-tool-hint-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-5">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h3><strong>{{ $t('measurement_tool_hint_dialog.quick_measurement_tool') }}</strong></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>{{ $t('measurement_tool_hint_dialog.measure_a_point_to_point_section') }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <img src="../../images/measurement_tool_hint.png" class="d-block img-fluid my-3">
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>{{ $t('measurement_tool_hint_dialog.while_the_measurement_tool_is_active') }} </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-primary btn-block" data-bs-dismiss="modal">{{ $t('shared.continue') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
});

</script>
